import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as repositoryActions from '../../../Store/Actions/repositoryActions';
import './forms.css';

import TextBox from '../TextBox/textbox';
import Button from '../Button/button';
import ComboBox from '../ComboBox/combobox';

/*
PARAMETERS :
  create : true/false
  object : {} // object to update or null if create = true,
  reservedValue : {COLUMNNAME:[ARRAY OF RESERVED VALUE]}
*/
class nace2Form extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
      page:0,
      create:true,
      endPoint:"EN3",
      blankObject:{
        AC_001: 0,
        ARCS: 0,
        ARCS_PER: 0,
        ARCS_TP_N3: 0,
        CODE: "",
        COMMENT: "",
        FLAG: 0,
        HISTORIQUE: 0,
        IU: "R",
        NSYS: 4,
        SIT: 0,
        Session: {},
        SessionIDE: "",
        Status: 0,
        WORDING: "",
      },
    };

  }

  // BUILDING METHOD DO NOT CHANGE
  componentDidMount = () =>{
    var node = {...this.props.node};
    // GET THE OBJECT IF ID is provided
    if(this.props.id > 0){
      this.props.get_single_object(this.props.sessionId,this.props.id,this.state.endPoint);
      this.setState({create:false});
    }else{
      // ELSE CREATE BLANK OBJECT AND TRIGGER ON CREATE
      var blankObject = {...this.state.blankObject};
      blankObject.ARCS_TP_N3 = this.props.node.ARCS_TP_N3;
      this.setState({create:true});
      this.props.onCreateBlank(blankObject);
    }
    
    node.ARCS_TP_N3 = this.props.parentId;
    this.props.get_list_object(this.props.sessionId,this.state.endPoint,node,true,this.state.page);
  }


  // INNER METHOD 

  //GENERIC DO NOT CHANGE
  onClickCancel = () =>{
    this.props.onCancelForm();
    
  }

  // MAY CHANGE
  // ADD ALERT MANAGEMENT FOR UNIQUE REF
  onClickValid = () =>{
    var object = this.props.newObject;
    if(this.state.create){
      // CHECK RESERVED VALUE UNIQUE CODE
          if(this.props.dataSet.map(item=>item.CODE).includes(object.CODE)){
            alert("the value : "+object.CODE+ " should be unique and is already in use for column :"+"CODE");
          }else{
            this.props.onSave(object);
          }
    }else{
      this.props.onSave(object);
    }

  }

  //GENERIC DO NOT CHANGE
  onUpdateValue = (columnName,e) =>{
    this.props.onUpdateValue(columnName,e,this.props.language);
  }

  //GENERIC
  onSelectedItems = (ids) =>{
    this.props.onUpdateValue("ARCS_PER",ids[0]);
  }


  render() {
    var content = this.props.newObject !== null ?
      <div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (id : {this.state.create?0:this.props.newObject.ARCS})</span>
            <div className="section-status valid"></div>
          </div>
          <div className="section-body">
            <div className={!this.state.create ? "section-item column-2 readOnly": "section-item column-2"}>
            <label>Code</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:this.state.create?false:true, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"CODE")}
              value = {this.props.newObject !== undefined? this.props.newObject["CODE"]:""}
            />
          </div>
          <div className="section-item column-2">
            <label>Comment</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:false, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"COMMENT")}
              value = {this.props.newObject !== undefined?this.props.newObject["COMMENT"]:""}
            />
          </div>
          <div className="section-item column-2">
            <label>Nace 1</label>
            {this.props.listOptions !== null?
              <ComboBox 
                onSelectItem={this.onSelectedItems.bind()}
                listItem={this.props.listOptions !== undefined?this.props.listOptions:[]}
                selectedItemIds={[this.props.newObject.ARCS_PER]}
                config={
                  {
                    id:"ARCS",
                    isSelectable:true,
                    multiple:false,
                    columns:[
                      {name:"CODE",type:"text"},{name:"WORDING",type:"number"}
                    ],
                    actions:[]
                  }
                }
              />
            :null}
          </div>
          <div className="section-item column-2">
              <label>Wording ({this.props.language})</label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"WORDING")}
                value = {this.props.newObject !== undefined? this.props.newObject.WORDING !== undefined?this.props.newObject.WORDING[this.props.language]:"":""}
              />
          </div>
        </div>
      </div>
        <div className="form-section">
        <div>
            <Button 
                preventMultipleClick={0} 
                config={
                  {
                    isEnabled:true,
                    icon:"check",
                    text:"save change",
                    color:null,
                    textAlign:"center",
                    bgcolor:null
                  }
                } 
                OnClickElement={this.onClickValid.bind(this)}
              />
            </div>
        </div>
      </div>
    :null;

    return (
      <div className="form-container" >
      {content}  
      </div>
    );
  }
}

const mapStateToProps = (state) => {    
  return {  
    newObject:state.apiReducer.newObject,
    sessionId: state.apiReducer.sessionId,
    dataSet:state.apiReducer.workingData,
    language:state.appReducer.language,
    listOptions:state.apiReducer.listOptions,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    get_single_object: (sessionId,id,endPoint) =>dispatch(repositoryActions.get_single_object(sessionId,id,endPoint)),
    onUpdateValue:(columnName,e,lang)=>dispatch(repositoryActions.onUpdateValue(columnName,e,lang)),
    onCreateBlank:(object)=>dispatch(repositoryActions.onCreateBlank(object)),
    get_list_object: (sessionId,endPoint,node,getOptions,page) =>dispatch(repositoryActions.get_list_object(sessionId,endPoint,node,getOptions,page)),
  } 
} 
  
  export default connect(mapStateToProps, mapDispatchToProps)(nace2Form);